import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap';
import firebase from "../../firebase/firebase-config";


const OrderCard = ({ data }) => {

    const [user, setuser] = useState({})
    const [date, setdate] = useState('')


    const get_user = () => {
        const user = firebase.firestore().collection('users').doc(data.userId).onSnapshot((user) => {

            setuser(user.data());


        })

        const date = new Date(data.date.seconds * 1000 + data.date.nanoseconds / 1000000);
        setdate(date.toString());

    }

    useEffect(() => {
        get_user();
    }, [])



    return (




        <Col md="4" key={data?.orderId}>
            <Card className="card-user shadow-lg">
                <CardBody>
                    <CardText />


                    <div className="d-flex justify-content-around" onClick={(e) => e.preventDefault()}>
                        <h6 className="title ">Order ID : {data?.orderId}</h6>
                        <hr />
                        {/* <h5 className="description">Order date: {data.date}</h5> */}
                    </div>
                    <div>
                        <div className="d-flex" style={{ color: 'white' }}>
                            Current Status : {data?.status == 'pending' ? <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(90deg, rgba(0,159,253,1) 0%, rgba(42,42,114,1) 100%)', borderRadius: '8px' }}>Pending</p> : data?.status == 'approved' ? <p className="font-weight-bold px-3 ml-2" style={{ background: ' linear-gradient(to right, #04FF00, #00FFAE)', borderRadius: '8px' }}>Approved</p> : data?.status == 'production' ? <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #FEE823, #9E9333)', borderRadius: '8px' }}>production</p> : data?.status == 'shipped' ? <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #606c88, #3f4c6b)', borderRadius: '8px' }}>Out For Delivery</p> : <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #4b6cb7, #182848)', borderRadius: '8px' }}>Delivered</p>}
                        </div>

                        <div className="d-flex " style={{ color: 'white' }}> Completion Status: {data.isCompleted == false ? <div className="  d-flex pl-2  font-weight-bolder"> <p className='font-weight-bold px-3' style={{ backgroundColor: '#DD011B', borderRadius: '8px', }}>Not Completed</p>    </div> : <div className="d-flex pl-2 " > <p className="font-weight-bold px-3" style={{ backgroundColor: '#30DF1E', borderRadius: '8px' }}>Completed</p>    </div>}
                        </div>
                        <h5 className="description">Order For: {user?.fullName} - @{user?.username}</h5>
                        <h5 className="description">Date: {date}</h5>

                    </div>


                    <div className="description" style={{ overflow: 'scroll', height: '200px' }}>Products:
                        {data?.products == '' ? <div className="d-flex justify-content-center align-items-center"> <p className="description " style={{ opacity: '0.5' }}>No Products!</p></div> : data?.products.map((pd) => {

                            return <div key={pd.id} className="my-2 ">
                                <div className="d-flex justify-content-between shadow-lg border rounded p-2">
                                    <div className="d-flex ">
                                        <div style={{ height: '50px' }}>
                                            <img src={pd.image} className="image-fluid" style={{ height: '100%', width: '100%' }} />
                                        </div>
                                        <div className="px-3">
                                            <p className=" font-weight-bolder ">{pd.name}</p>
                                            {/* //TODO: add product size */}

                                            <div className="d-flex justify-content-between " >
                                                <p className=" font-weight-bolder" style={{ color: '#1CACE3' }}>AED</p>
                                                <p className=' pl-2 '>{pd.price} x {pd.quantity}</p>
                                            </div>




                                        </div>
                                    </div>

                                    <p className='flex-end'>Total Amount : {pd.totalPrice} AED</p>
                                </div>
                            </div>
                        })}
                    </div>

                </CardBody>
                <CardFooter>
                    <div className="button-container d-flex justify-content-around align-items-center">
                        <Link to={`/admin/Total-Orders/Single-Order/${data?.orderId}`}>

                            <div className="btn btn-round" color="facebook">
                                See Order
                            </div>
                        </Link>
                        <h4>Total Amount : {data?.amount} AED</h4>


                    </div>

                </CardFooter>
            </Card>

        </Col >

    );

}

export default OrderCard